module.exports = __webpack_public_path__ + "img/emo_21.87d6817e.png";